/* ============
 * Appointment Util
 * ============
 */
import moment from 'moment-timezone';
import timeSlotUtil from './timeSlot';
import patientUtil from './patient';
import dateUtil from './dateTime';

export default {
  type(appointment) {
    return `${this.appoint(appointment)}, ${this.initial(appointment)}`;
  },
  appointWithTime(appointment) {
    // appointed or see now
    if (appointment.due) {
      const time = moment.tz(appointment.due, timeSlotUtil.getLocalTimeZone()).format('kk:mm');
      return window.Vue.t('appointment.type.appointment_time', { time });
    }
    return window.Vue.t('appointment.type.walkin');
  },
  time(appointment) {
    if (appointment.due) {
      return moment.tz(appointment.due, timeSlotUtil.getLocalTimeZone()).format('kk:mm');
    }
    return window.Vue.t('appointment.type.walkin');
  },
  date(appointment, locale) {
    if (appointment.due) {
      const dueMoment = moment.tz(appointment.due, timeSlotUtil.getLocalTimeZone());
      dueMoment.locale(locale);
      return dueMoment.format('LL');
    }
    return '';
  },
  appoint(appointment) {
    // appointed or see now
    return window.Vue.t(`appointment.type.${appointment.type}`);
  },
  initial(appointment) {
    // initial visit or follow up
    if (!appointment.reserved_duration) {
      // backward compatibility support for old appointment.
      let initial = 'initial';
      if (appointment.followup) {
        initial = 'follow_up';
      }
      return window.Vue.t(`appointment.initial.${initial}`);
    }
    // new appointment have reserved_duration
    if (appointment.reserved_duration === 15 || appointment.reserved_duration === 60) {
      return window.Vue.t(`appointment.initial.reserved${appointment.reserved_duration}`);
    }
    // reserved_duration == 30
    return window.Vue.t('appointment.initial.reserved30');
  },
  visitDuration(appointment) {
    return appointment.reserved_duration ? appointment.reserved_duration : timeSlotUtil.getSlotSize();
  },
  convertDate(appointment) {
    const newObj = Object.assign({}, appointment);
    newObj.wait = newObj.wait ? timeSlotUtil.convertTimeString(newObj.wait) : newObj.wait;
    newObj.last_wait = newObj.last_wait ? timeSlotUtil.convertTimeString(newObj.last_wait) : newObj.last_wait;
    newObj.start = newObj.start ? timeSlotUtil.convertTimeString(newObj.start) : newObj.start;
    newObj.end = newObj.end ? timeSlotUtil.convertTimeString(newObj.end) : newObj.end;
    newObj.due = newObj.due ? timeSlotUtil.convertTimeString(newObj.due) : newObj.due;
    newObj.created = timeSlotUtil.convertTimeString(newObj.created);
    return newObj;
  },
  canGoToWaitingRoom(appointment) {
    if (appointment.type === 'walkin') {
      return appointment.status === 'pending';
    }
    const allowStatus = ['pending', 'ongoing'];
    if (appointment.end || allowStatus.indexOf(appointment.status) < 0) {
      return false;
    }
    const due = moment.tz(appointment.due, timeSlotUtil.getLocalTimeZone()).unix();
    const now = moment.tz(timeSlotUtil.getLocalTimeZone()).unix();
    return due - now < 600;
  },
  medicalRecordAllowed(appointment) {
    return appointment.medical_record === 'allowed';
  },
  patientName(appointment) {
    let fullName = '';
    if (appointment.patient_firstname) {
      fullName += appointment.patient_firstname;
      if (appointment.patient_lastname) {
        fullName += ` ${appointment.patient_lastname}`;
      }
    } else {
      fullName += patientUtil.name(appointment.patient_profile);
    }
    return fullName;
  },
  patientAge(appointment) {
    if (appointment.patient_age) {
      return appointment.patient_age;
    }
    return dateUtil.computeAge(appointment.patient_profile.birthdate);
  },
  patientGender(appointment) {
    if (appointment.patient_gender) {
      return appointment.patient_gender;
    }
    return appointment.patient_profile.gender;
  },
};
